// removed by extract-text-webpack-plugin
module.exports = {"user-profile":"user-profile","mobile-navigation":"mobile-navigation","page-header":"page-header","header-nav-right":"header-nav-right","hdr-btn":"hdr-btn","header-nav-left":"header-nav-left","user-account-btn":"user-account-btn","dropdown-menu":"dropdown-menu","headerSiteTitle":"headerSiteTitle"};
    if(module.hot) {
      // 1603801293233
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/components/structurals/header.component.scss
// module id = 1113
// module chunks = 0